import script from "./print_imgs.vue?vue&type=script&setup=true&lang=js"
export * from "./print_imgs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__